export default __webpack_public_path__ + "07281f6b0b01a3a98cd0aaa33b6d56a4.png";